import React from "react";
import styles from "./style.module.css";

interface Props {
  type?: "h1";
  title: string;
  subTitle?: string;
  style?: React.CSSProperties;
}

export default function Title({ title, subTitle, type = "h1", style }: Props) {
  const lineBreak = (value?: string) =>
    value
      ? value.split("\\n").map((v, i) => (i ? [<br key={i} />, v] : v))
      : "";

  const titleValue = lineBreak(title);
  const subTitleValue = lineBreak(subTitle);

  const titleDom: Record<string, React.ReactNode> = {
    h1: <h1 className={styles.h1}>{titleValue}</h1>,
  };

  return (
    <div className={styles.wrap} style={{ ...style }}>
      {titleDom[type]}
      {subTitle && <p className={styles.subTitle}>{subTitleValue}</p>}
    </div>
  );
}
